import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7673d2f169cc38d0ebd608b124ce89d5.jpg"
          alt="Storm damaged roof"
          className="w-full h-full object-cover object-top brightness-[0.56]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080E18]/88 via-[#0D1A2E]/76 to-[#0D1A2E]/58" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080E18]/72 via-transparent to-[#080E18]/22" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-20">
        <div
          className={`max-w-2xl transition-all duration-1000 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="inline-flex items-center gap-2 bg-[#1B78D4]/25 border border-[#1B78D4]/60 rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 bg-[#5BA8E5] rounded-full animate-pulse" />
            <span className="text-[#5BA8E5] text-sm font-semibold tracking-wide">Licensed Public Adjusters</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
            Get the Insurance
            <span className="text-[#1B78D4] block drop-shadow-[0_0_20px_rgba(27,120,212,0.4)]">Payout You Deserve</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 font-light mb-3 leading-relaxed">
            We fight the insurance company so you don't have to.
          </p>
          <p className="text-base text-gray-400 mb-10 max-w-xl leading-relaxed">
            Roof damage, storm damage, hurricane, water damage — our expert public adjusters maximize
            your insurance claim and handle everything from start to finish.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo('booking')}
              className="bg-[#1B78D4] hover:bg-[#1464BB] active:scale-95 text-white font-bold text-base px-10 py-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap shadow-[0_4px_24px_rgba(27,120,212,0.45)] hover:shadow-[0_6px_32px_rgba(27,120,212,0.6)]"
            >
              <i className="ri-calendar-check-line text-lg" />
              Book Free Inspection
            </button>
            <button
              onClick={() => scrollTo('booking')}
              className="border-2 border-white/50 hover:border-[#1B78D4] hover:bg-[#1B78D4]/15 text-white font-bold text-base px-10 py-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-search-eye-line text-lg" />
              Get Free Claim Review
            </button>
          </div>

          <div className="mt-12 flex flex-wrap gap-6">
            {[
              { icon: 'ri-shield-check-line', text: 'No Recovery, No Fee' },
              { icon: 'ri-award-line', text: 'Licensed & Certified' },
              { icon: 'ri-time-line', text: '24hr Response Time' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${item.icon} text-[#1B78D4] text-lg`} />
                </div>
                <span className="text-gray-300 text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={() => scrollTo('trust')}
          className="text-[#5BA8E5] animate-bounce cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl" />
        </button>
      </div>
    </section>
  );
}
